import { render, staticRenderFns } from "./page_header.vue?vue&type=template&id=3a8f7c24&scoped=true"
import script from "./page_header.vue?vue&type=script&lang=js"
export * from "./page_header.vue?vue&type=script&lang=js"
import style0 from "./page_header.vue?vue&type=style&index=0&id=3a8f7c24&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./page_header.vue?vue&type=style&index=2&id=3a8f7c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f7c24",
  null
  
)

export default component.exports